import { IAudioSurah } from '../interfaces/i-audio-surah';
import { IReciter } from '../interfaces/i-reciter';
import { AudioSurah } from './audio-surah';
import { Reciter } from './reciter';

export class ReciterAudioSurah {
  title: string;
  reciter: Reciter;
  audioSurah: AudioSurah;

  constructor(reciter: IReciter, audioSurah: IAudioSurah) {
    this.title = reciter.title_en;
    this.reciter = new Reciter(reciter);
    this.audioSurah = new AudioSurah(audioSurah);
  }
}
